package foatto.core_compose_web.model

class TabInfo(
    val id: Int,
    var alText: List<String>,
    var tooltip: String,
)
